module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("PRIME MINISTERS FROM 1945")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Clement Attlee, Labour, 1945–51")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Winston Churchill, Conservative, 1951–55")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Anthony Eden, Conservative, 1955–57")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Harold Macmillan, Conservative, 1957–63")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Alec Douglas-Home, Conservative, 1963–64")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Harold Wilson, Labour, 1964–70")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Edward Heath, Conservative, 1970–74")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Harold Wilson, Labour, 1974–76")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("James Callaghan, Labour, 1976–79")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Margaret Thatcher, Conservative, 1979–90")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("John Major, Conservative, 1990–97")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Tony Blair, Labour, 1997–2007")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Gordon Brown, Labour, 2007–10")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("David Cameron, Conservative, 2010–16")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Theresa May, Conservative, 2016–")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f76bc29e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Fm02.vue
// module id = 81
// module chunks = 0